import styled from "@emotion/styled"
import colors from "theme/colors"
import { Desktop, Mobile, NewText, TitleWithLine } from "ui"
import { extractProperty } from "utils"

const StyledPersonsWrapper = styled.div`
  padding: 0px 20px 40px 20px;
  padding-top: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0px 146px 0 146px;
    padding-top: 60px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0px 220px 0 220px;
    padding-top: 80px;
  }
`
type Props = {
  data: any
}

function BaseTitle({ data }: Props) {
  const title = extractProperty(data, "sideMenuTitle")
  return (
    <StyledPersonsWrapper>
      <Desktop>
        <NewText
          component={"h2"}
          largeDesktopFontSize={64}
          largeDesktopLineHeight="80px"
          desktopFontSize={42}
          desktopLineHeight={"53.33px"}
          desktopFontWeight={500}
          mobileFontSize={36}
          mobileLineHeight={"50.4px"}
        >
          {title}
        </NewText>
      </Desktop>
      <Mobile>
        <TitleWithLine
          title={title}
          largeDesktopFontSize={64}
          largeDesktopLineHeight="80"
          titleFontSize={42}
          desktopLineHeight={"53.33px"}
          desktopFontWeight={500}
          mobileTitleFontSize={36}
          mobileLineHeight={"50.4px"}
          titleColor={colors.black}
        />
      </Mobile>
    </StyledPersonsWrapper>
  )
}

export default BaseTitle
